import React from "react";
import PropTypes from "prop-types";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Field from "../../../components/Field";
import FieldCheck from "../../../components/FieldCheck";
import {Panel} from "../../../components/Panel";
import noty from "../../../lib/noty";
import SubscriptionStatus from "../../../components/SubscriptionStatus";
import {checkAccountEditPermission} from "../../../components/Utilities";
import "./style.scss";

export default class CurrentAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      touched: false,
      currentAccount: props.currentAccount
    };
  }

  handleChange = ({name, value}) => {
    const path = name.split(".");
    this.setState({
      touched: true,
      currentAccount: this.state.currentAccount.setIn(path, value)
    });
  };

  handleSubmit = async event => {
    event.preventDefault();
    const {currentAccount} = this.state;
    this.setState({fetching: true});
    try {
      await currentAccount.patch();
      this.setState({fetching: false, touched: false});
      noty.success("Account updated.");
    } catch (err) {
      this.setState({fetching: false});
      noty.errors(err);
    }
  };

  getPriceText(plan) {
    return plan.name === "Enterprise"
      ? "Enterprise pricing depends on your specific needs. Please contact us."
      : `$${plan.price} a month`;
  }

  getPlanDescription(plan) {
    return (
      <div className="planExpand">
        <p>{plan.description}</p>
        <p>The {plan.name} plan includes:</p>
        <ul>
          {plan.features.map(feature => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      </div>
    );
  }

  renderPlans(plans) {
    const {currentAccount, fetching} = this.state;
    return (
      <List className="planList">
        {plans.toList().map(plan => {
          const selectedPlanDesc = currentAccount.plan_id === plan._id && this.getPlanDescription(plan);
          return (
            <React.Fragment key={plan._id}>
              <ListItem>
                <ListItemIcon>
                  <FieldCheck
                    name="plan_id"
                    value={plan._id}
                    onChange={this.handleChange}
                    checked={currentAccount.plan_id === plan._id}
                    disabled={fetching}
                  />
                </ListItemIcon>
                <ListItemText primary={`${plan.name} plan`} secondary={this.getPriceText(plan)} />
              </ListItem>
              {selectedPlanDesc ? (
                <ListItem>
                  <ListItemText primary={selectedPlanDesc} />
                </ListItem>
              ) : null}
            </React.Fragment>
          );
        })}
      </List>
    );
  }

  renderAccountEditorExpiredNotice() {
    return (
      <React.Fragment>
        <p style={{fontWeight: "bold", marginTop: "10px"}}>
          <span style={{color: "red"}}>Your free trial has ended. </span>
          Please add a credit card to continue using MapPlug.
        </p>
        <p>
          If you need anything, please use the chat below or email us at{" "}
          <a href="mailto:info@mapplug.com">info@mapplug.com</a>
        </p>
      </React.Fragment>
    );
  }

  renderNonEditorExpiredNotice() {
    const {ownerName} = this.props;
    return (
      <React.Fragment>
        <p style={{fontWeight: "bold", marginTop: "10px"}}>Your free trial has ended.</p>
        <p>
          To get access again, tell your account owner, {ownerName}, to set up billing to restore the system for you.
        </p>
        <p>
          If you need anything, please use the chat below or email us at{" "}
          <a href="mailto:info@mapplug.com">info@mapplug.com</a>
        </p>
      </React.Fragment>
    );
  }

  render() {
    const {currentAccount, touched, fetching} = this.state;
    const {plans, currentUser, permissions, subscriptionStatus} = this.props;
    let {active} = subscriptionStatus;
    const accountEditPermission = checkAccountEditPermission({
      permissions,
      currentUser
    });

    let statusNotice = null;
    if (!active) {
      statusNotice = accountEditPermission
        ? this.renderAccountEditorExpiredNotice()
        : this.renderNonEditorExpiredNotice();
    }

    return (
      <div id="CurrentAccount" className="margin-bottom-30">
        <Panel
          onSaveClick={this.handleSubmit}
          saveTitle="Save Account"
          touched={touched}
          fetching={fetching}
          touchedMessage="Are you sure you want to leave? Your account has unsaved changes.">
          {statusNotice}
          <Field
            disabled={fetching}
            label="Organization Name"
            name="name"
            value={currentAccount.name}
            onChange={this.handleChange}
          />
          <Field
            disabled={fetching}
            label="Organization Email"
            name="billing_email"
            value={currentAccount.billing_email}
            onChange={this.handleChange}
          />
          {this.renderPlans(plans)}
        </Panel>
      </div>
    );
  }
}

CurrentAccount.propTypes = {
  plans: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  currentAccount: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  subscriptionStatus: PropTypes.instanceOf(SubscriptionStatus),
  ownerName: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/pages/Account/CurrentAccount/index.jsx